module.exports = __webpack_public_path__ + "static/sphere_map-6dcc03575bfff7a7083159ab5aebfd03.png";